import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {interval, Subscription} from 'rxjs';

@Component({
  selector: 'app-countdown-timer',
  templateUrl: './countdown-timer.component.html',
  styleUrls: ['./countdown-timer.component.scss']
})
export class CountdownTimerComponent implements OnInit, OnDestroy {
  remaining: string | number = '--:--';
  timerSubscription: Subscription;
  @Input() end: number;
  @Output() zeroTrigger: EventEmitter<any> = new EventEmitter(true);

  constructor() {
  }

  ngOnInit() {
    let startedAt;
    this.timerSubscription = interval(1000)
      .subscribe(() => {
        let remains;
        if (this.end) {
          remains = this.end - new Date().getTime();
          if (!startedAt) startedAt = remains;
        }
        if (remains && remains > 0) this.remaining = this.dhm(remains);
        else {
          this.remaining = '--:--';
          this.timerSubscription.unsubscribe();
          if (startedAt > 0) this.zeroTrigger.emit(true);
        }
      });
  }

  ngOnDestroy(): void {
    if (this.timerSubscription) this.timerSubscription.unsubscribe();
  }

  dhm(ms) {
    let minutes = Math.floor((ms) / (60 * 1000));
    let minutesms = ms % (60 * 1000);
    let sec = Math.floor((minutesms) / (1000));
    return minutes+ ':' + (sec < 10 ? '0' + sec : sec);
  }

}
